import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showRank?: number;
}

export default function ComicCard({ comic, showRank }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} - 奇妙漫画免费在线阅读`}
          title={`${comic.title} | 奇妙漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        {showRank && showRank <= 3 && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
            {showRank}
          </div>
        )}
        {showRank && showRank > 3 && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-full bg-foreground-700/70 text-background-50 text-xs font-bold">
            {showRank}
          </div>
        )}
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '已完结'
              ? 'bg-accent-500 text-background-50'
              : 'bg-primary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3 pt-8">
          <span className="text-background-50 text-xs whitespace-nowrap">
            {comic.latestChapter}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-foreground-900 text-sm font-bold truncate group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {comic.rating}
          </span>
          <span className="whitespace-nowrap">{formatViews(comic.views)}</span>
        </div>
      </div>
    </Link>
  );
}